<template>
    <app-layout :footer="$route.name !== '文档详情' && $route.name !== '文档首页'">
        <router-view></router-view>
    </app-layout>
</template>

<script>
import AppLayout from '../../components/layout/app-layout';

export default {
    name: 'Document',
    components: { AppLayout }
};
</script>
